<template>
    <div>
        <ShowAllOrders orderStatus="partnerNation"></ShowAllOrders>
    </div>
    </template>
    
    <script>
    import ShowAllOrders from '@/components/App/dashboard/ShowAllOrders.vue';
    export default {
        name: "PartnerNationTab",
        components: {
            ShowAllOrders
        }
    }
    </script>
    
    <style>
    </style>